import React, { useState, useEffect } from 'react'
import { postMessage } from './api'
import { isEmail } from 'servos/formValidations'
import { Modal } from 'react-bootstrap'
import GenericIcon from '../../components/GenericIcon'

function App() {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [continueEnabled, setContinueEnabled] = useState(false)
  const [emailValidationMessage, setEmailValidationMessage] = useState('')
  const [showForm, setShowForm] = useState(true)
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false)

    // Clear data when modal is closed
    setTimeout(() => {
      setShowForm(true)
      setEmail('')
      setMessage('')
      setEmailValidationMessage('')
    }, 500)
  }

  const handleShow = () => setShow(true);

  const onSubmitSuccess = () => {
    setShowForm(false)

    setTimeout(() => {
      handleClose(false)
    }, 2000)
  }

  const onSubmitFailure = () => {
    // do something on failure
  }

  useEffect(() => {
    if (message.length && email.length) {
      setContinueEnabled(true)

      if (!isEmail(email)) {
        setEmailValidationMessage('Please enter a valid email address.')
        setContinueEnabled(false)
      } else {
        setEmailValidationMessage('')
      }
    } else {
      setContinueEnabled(false)
    }
  })

  const onSubmit = () => {
    postMessage(
      { email, message },
      onSubmitSuccess,
      onSubmitFailure
    )
  }

  return (
    <div>
      <button className="btn btn-green mt-4" onClick={ handleShow }>Send email</button>

      <Modal show={show} onHide={handleClose} className='modal modal--send-email fade' id='modal-send-email'>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className="icon d-flex justify-content-center mb-4">
            <GenericIcon name='email' />
          </div>

          { showForm &&
            <div>
              <div className="text-center">
                <h4>Send an email</h4>
                <p className="grey">Fill in the form below, or send an email to hello@yard.com.au</p>
              </div>

              <div className='form-group'>
                <label htmlFor='contact-form-email'>Email address</label>
                <input value={ email }
                       onChange={ e => setEmail(e.target.value) }
                       id='contact-form-email'
                       className={ `form-control ${emailValidationMessage.length ? ' is-invalid ' : ''}` }
                       type='email'
                       required />

                <div className="invalid-feedback">
                  { emailValidationMessage }
                </div>
              </div>

              <div className='form-group'>
                <label htmlFor='contact-form-message'>Message</label>
                <textarea onChange={ e => setMessage(e.target.value) }
                          value={ message }
                          id='contact-form-message'
                          className='form-control'
                          rows='5'
                          required>
                </textarea>
              </div>

              <button disabled={!continueEnabled}
                      className='btn btn-green btn-block btn-lg'
                      onClick={ onSubmit }
              >
                Submit interest
              </button>
            </div>
          }

          { !showForm &&
            <div className='text-center'>
              Thank you! We'll contact you soon.
            </div>
          }
        </Modal.Body>
        <Modal.Footer>

        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default App
